<template>
  <div class="convert" style="100%;height: 100%;display:flex;flex-direction: column;">
    <div style="display:flex;flex-direction: column;width:100%;height: 100%;align-items: center;">
      <div v-if="status == 1" style="width: 100%;margin-top: 25%;">
        <p class="convert4" :style="style5">兑换VIP</p>
        <div style="width: 100%;">
          <div style="width: 100%;display: flex;align-items: center;flex-direction: column;margin: auto;">
            <input class="convert8" v-model="account" placeholder="手机或邮箱" :style="style" />
            <div class="convert7" :style="style2">
              <span>*必须使用您绑定的手机号或邮箱，未成功绑定无法使用兑换码</span>
            </div>
            <input class="convert5" v-model="code" placeholder="兑换码" :style="style6" />
            <el-button plain :style="style4" @click="confirm()">
              确定
            </el-button>
          </div>
        </div>

      </div>
      <div v-if="status == 0" class="convert6" :style="style5">恭喜兑换成功，您的账号({{account}})VIP时间增加了{{addVipDays}}天</div>
    </div>
    <div class="convert3" :style="style3">
      <p> Copyright 2019 - 2029 | All Rights Reserved IOOFOX 深圳市云方程数据技术有限公司 | <a href="https://beian.miit.gov.cn/"
          target="_blank">粤ICP备2022061985号</a></p>
    </div>
  </div>
</template>

<script>

import { convert } from '@/api/vip';

export default {
  name: "convert",
  mounted: function () {
  },
  created() {

    document.title = '兑换VIP'

    let windowWidth = document.documentElement.clientWidth  //实时屏幕宽度
    let windowHeight = document.documentElement.clientHeight   //实时屏幕高度
    this.imgWAndH = (windowHeight * 0.2) + 'px';
    this.style = {
      "font-size": (windowHeight * 0.025) + 'px',
      "padding": '20px 0 20px 0',
      "height": (windowHeight * 0.05) + 'px',
      "border": "1px solid #d2d2d2",
      "background-color": "transparent",
      'width': (windowWidth * 0.75) + 'px',
      'padding': '20px 30px 20px 30px',
    }
    this.style6 = {
      "font-size": (windowHeight * 0.025) + 'px',
      "padding": '20px 0 20px 0',
      "height": (windowHeight * 0.05) + 'px',
      "border": "1px solid #d2d2d2",
      "background-color": "transparent",
      'width': (windowWidth * 0.75) + 'px',
      'padding': '20px 30px 20px 30px',
    }
    this.style3 = {
      "font-size": (windowHeight * 0.01) + 'px',
    }
    this.style5 = {
      "font-size": (windowHeight * 0.03) + 'px',
    }
    this.style4 = {
      'width': (windowWidth * 0.82) + 'px',
      'font-size': (windowWidth * 0.05) + 'px',
      'height': (windowHeight * 0.07) + 'px',
      'font-family': 'Microsoft YaHei',
      'font-weight': '400',
      'margin-top': '60px',
      'background-color': '#abf7fc',
      'color': '#3a80bf',
    }
    this.style2 = {
      'width': (windowWidth * 0.82) + 'px',
      "font-size": (windowHeight * 0.017) + 'px',
    }

  },
  methods: {
    confirm() {
      let data = {
        account: this.account,
        code: this.code
      }
      return new Promise((resolve, reject) => {
        convert(data).then(res => {
          if (res.status == 200) {
            this.status = 0
            this.addVipDays = res.data.addVipDays
          } else {
            let str = '<span style="font-size:40px;">' + res.message + '</span>'
            this.$message({
              message: str,
              type: 'error',
              dangerouslyUseHTMLString: true,
            });
          }
        });
      })
    }
  },
  data() {
    return {
      addVipDays: 0,
      status: 1,
      account: '',
      code: '',
      form: {
        account: '',
        code: '',
      },
      imgWAndH: '',
      style: {},
      style2: {},
      style4: {},
      style3: {},
      style5: {},
      style6: {},
    };
  },
};
</script>

<style>
.convert {
  background-image: url('../../assets/convert.png');
  background-repeat: no-repeat;
  background-position: center center;
  background-attachment: fixed;
  background-size: cover;
}

.convert1 {
  display: flex;
  flex-direction: column;
  text-align: center;
}

.convert2 {
  text-decoration: none;
  display: block;
  text-align: center;
  background-color: #6495ED;
  border-radius: 20px;
  color: white;
}

.convert3 {
  text-align: center;
  width: 100%;
  background-color: black;
  display: table-cell;
  color: #ffffff;
  font-size: 10px;
}

.convert3 a {
  text-decoration: none;
  color: #ffffff;
}

.convert4 {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
}

.convert5 {
  margin: 5% 0 5% 0;
  color: #ffffff;
}
.convert8 {
  margin: 5% 0 0 0;
  color: #ffffff;
}
.convert6 {
  width: 90%;
  text-align: center;
  margin-top: 65%;
  color: yellow;
}

.el-message_content {
  font-size: 50px;
}

input::-webkit-input-placeholder {

  color: #ffffff;

}

.convert7 {
  color: yellow;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/vip/convert.vue